<template>
  <div class="about-container width100">
    <!-- Video de fondo -->
    <div class="video-container">
      <div class="video-wrapper">
        <video
          :src="require('@/assets/mina_video2.mp4')"
          poster="../../assets/video-cobre.jpeg"
          autoplay
          muted
          loop
          playsinline
          class="video"
          id="video"
        ></video>
      </div>
    </div>

    <!-- Sección About Us -->
    <div class="about-section">
      <div class="image-gallery">
        <div class="image-left">
          <img
            :src="
              searchImage('IMAGE_HOME_01') !== null
                ? searchImage('IMAGE_HOME_01')
                : `${BASEURL}/img/about-01.jpg`
            "
            @error="
              (e) => {
                e.target.src = `${BASEURL}/img/about-01.jpg`;
              }
            "
            alt="about-01"
            loading="lazy"
          />
        </div>
        <div class="image-right">
          <kinesis-container event="scroll">
            <kinesis-element
              :strength="100"
              axis="x"
              type="translate"
              style="display: inline-block"
            >
              <img
                :src="
                  searchImage('IMAGE_HOME_02') !== null
                    ? searchImage('IMAGE_HOME_02')
                    : `${BASEURL}/img/about-02.jpg`
                "
                @error="
                  (e) => {
                    e.target.src = `${BASEURL}/img/about-02.jpg`;
                  }
                "
                alt="about-02"
                loading="lazy"
              />
            </kinesis-element>
          </kinesis-container>
        </div>
      </div>
      <div class="about-content">
        <div class="text-start">
          <h2><span v-html="filterData('HOME_01_' + language)"></span></h2>
          <p class="p-big">
            <span v-html="filterData('HOME_02_' + language)"></span>
          </p>
          <button class="btn-red" @click="seeMore">
            <span v-if="language === 'EN'">SEE MORE</span>
            <span v-else>VER MÁS</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Sección ESG -->
    <section class="esg-section">
      <div class="about-info">
        <div>
          <h2><span v-html="filterData('HOME_03_' + language)"></span></h2>
        </div>

        <div class="esg-container">
          <!-- Tarjeta Comunidades -->
          <div class="esg-card">
            <div class="esg-image-placeholder">
              <img
                :src="
                  searchImage('IMAGE_HOME_03') !== null
                    ? searchImage('IMAGE_HOME_03')
                    : `${BASEURL}/img/esg-communities.jpg`
                "
                loading="lazy"
                @error="
                  (event) =>
                    (event.target.src = `${BASEURL}/img/esg-communities.jpg`)
                "
                alt="commununitis"
              />
            </div>
            <div class="esg-content">
              <h4><span v-html="filterData('HOME_04_' + language)"></span></h4>
              <p>
                <span v-html="filterData('HOME_05_' + language)"></span>
              </p>
              <div v-if="language === 'EN'">
                <button class="btn-black" @click="seeMoreEsg">SEE MORE</button>
              </div>
              <div v-else>
                <button class="btn-black" @click="seeMoreEsg">VER MÁS</button>
              </div>
            </div>
          </div>

          <!-- Tarjeta Salud y Seguridad -->
          <div class="esg-card">
            <div class="esg-image-placeholder">
              <img
                :src="
                  searchImage('IMAGE_HOME_04') !== null
                    ? searchImage('IMAGE_HOME_04')
                    : `${BASEURL}/img/esg-health-and-safety.jpg`
                "
                loading="lazy"
                @error="
                  (event) =>
                    (event.target.src = `${BASEURL}/img/esg-health-and-safety.jpg`)
                "
                alt="health-and-safety"
              />
            </div>
            <div class="esg-content">
              <h4><span v-html="filterData('HOME_06_' + language)"></span></h4>
              <p>
                <span v-html="filterData('HOME_07_' + language)"></span>
              </p>
              <div v-if="language === 'EN'">
                <button class="btn-black" @click="seeMoreEsg">SEE MORE</button>
              </div>
              <div v-else>
                <button class="btn-black" @click="seeMoreEsg">VER MÁS</button>
              </div>
            </div>
          </div>

          <!-- Tarjeta Agua y Medio Ambiente -->
          <div class="esg-card">
            <div class="esg-image-placeholder">
              <img
                :src="
                  searchImage('IMAGE_HOME_05') !== null
                    ? searchImage('IMAGE_HOME_05')
                    : `${BASEURL}/img/esg-water-environment.jpg`
                "
                loading="lazy"
                @error="
                  (event) =>
                    (event.target.src = `${BASEURL}/img/esg-water-environment.jpg`)
                "
                alt="water-environment"
              />
            </div>
            <div class="esg-content">
              <h4><span v-html="filterData('HOME_08_' + language)"></span></h4>
              <p>
                <span v-html="filterData('HOME_09_' + language)"></span>
              </p>
              <div v-if="language === 'EN'">
                <button class="btn-black" @click="seeMoreEsg">SEE MORE</button>
              </div>
              <div v-else>
                <button class="btn-black" @click="seeMoreEsg">VER MÁS</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Sección Galería -->
    <section class="gallery-section">
      <div class="about-info">
        <v-row>
          <v-col cols="12" md="6">
            <div v-if="language === 'EN'">
              <h2 class="text-start">Gallery</h2>
            </div>
            <div v-else>
              <h2 class="text-start">Galería</h2>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <div v-if="language === 'EN'" class="text-end m0">
              <button class="btn-red" @click="seeMoreGallery">
                SEE MORE
              </button>
            </div>
            <div v-else class="text-end m0">
              <button class="btn-red" @click="seeMoreGallery">
                VER MÁS
              </button>
            </div>
          </v-col>
        </v-row>

        <div class="carousel-container">
          <div class="carousel-track">
            <!-- Imágenes del carrusel (siempre visibles) -->
            <div class="carousel-slide">
              <div class="gallery-image-placeholder">
                <img
                  :src="
                    searchImage('IMAGE_HOME_06') !== null
                      ? searchImage('IMAGE_HOME_06')
                      : `${BASEURL}/img/hidrometalurgia-01.jpg`
                  "
                  alt="hidrometalurgia"
                  @error="
                    (event) =>
                      (event.target.src = `${BASEURL}/img/hidrometalurgia-01.jpg`)
                  "
                />
              </div>
            </div>
            <div class="carousel-slide">
              <div class="gallery-image-placeholder">
                <img
                  :src="
                    searchImage('IMAGE_HOME_07') !== null
                      ? searchImage('IMAGE_HOME_07')
                      : `${BASEURL}/img/mina-01.jpg`
                  "
                  alt="mina-01"
                  @error="
                    (event) => (event.target.src = `${BASEURL}/img/mina-01.jpg`)
                  "
                />
              </div>
            </div>
            <div class="carousel-slide">
              <div class="gallery-image-placeholder">
                <img
                  :src="
                    searchImage('IMAGE_HOME_08') !== null
                      ? searchImage('IMAGE_HOME_08')
                      : `${BASEURL}/img/mina-02.jpg`
                  "
                  alt="mina-02"
                  @error="
                    (event) => (event.target.src = `${BASEURL}/img/mina-02.jpg`)
                  "
                />
              </div>
            </div>
            <!-- Imágenes condicionales (solo se muestran si están en la base de datos) -->
            <div class="carousel-slide" v-if="searchImage('IMAGE_HOME_09') !== null">
              <div class="gallery-image-placeholder">
                <img
                  :src="searchImage('IMAGE_HOME_09')"
                  alt="trituracion"
                />
              </div>
            </div>
            <div class="carousel-slide" v-if="searchImage('IMAGE_HOME_10') !== null">
              <div class="gallery-image-placeholder">
                <img
                  :src="searchImage('IMAGE_HOME_10')"
                  alt="trituracion"
                />
              </div>
            </div>
            <div class="carousel-slide" v-if="searchImage('IMAGE_HOME_11') !== null">
              <div class="gallery-image-placeholder">
                <img
                  :src="searchImage('IMAGE_HOME_11')"
                  alt="trituracion"
                />
              </div>
            </div>
          </div>
          <button class="carousel-btn prev" @click="prevSlide">&#10094;</button>
          <button class="carousel-btn next" @click="nextSlide">&#10095;</button>
        </div>
      </div>
    </section>
  </div>
  <DocumentsBySection sectionName="General" />
</template>

<script>
import { BASEURL, getLanguage } from "@/kernel/utils";
import {
  getSectionByPageandlanguage,
  getImageBySection,
} from "@/modules/sections/services/sections-service";
import router from "@/router";
import { ref, onMounted, computed } from "vue";
import DocumentsBySection from "@/public/components/DocumentsBySection.vue";

export default {
  name: "HomePage",
  components: {
    DocumentsBySection,
  },
  setup() {
    const seeMore = async () => {
      await router.push("/about");
      window.scrollTo(0, 0);
    };

    const currentSlide = ref(0);
    const imagesAbout = ref([]);

    // Computed property para calcular el número total de slides disponibles
    const availableSlides = computed(() => {
      let count = 2; // IMAGE_HOME_06, IMAGE_HOME_07, IMAGE_HOME_08 siempre están
      
      // Verificar si las imágenes condicionales existen en la base de datos
      if (searchImage('IMAGE_HOME_09') !== null) count++;
      if (searchImage('IMAGE_HOME_10') !== null) count++;
      if (searchImage('IMAGE_HOME_11') !== null) count++;
      
      return count;
    });

    const nextSlide = () => {
      currentSlide.value = (currentSlide.value + 1) % availableSlides.value;
      updateCarousel();
    };

    const prevSlide = () => {
      currentSlide.value =
        (currentSlide.value - 1 + availableSlides.value) % availableSlides.value;
      updateCarousel();
    };

    const updateCarousel = () => {
      const track = document.querySelector(".carousel-track");
      const slideWidth = document.querySelector(".carousel-slide").offsetWidth;
      track.style.transform = `translateX(-${
        currentSlide.value * slideWidth
      }px)`;
    };

    const seeMoreEsg = async () => {
      await router.push("/esg");
      window.scrollTo(0, 0);
    };

    const seeMoreGallery = async () => {
      await router.push("/gallery");
      window.scrollTo(0, 0);
    };

    const dataHome = ref([
      {
        section_id: "HOME_01_EN",
        description: "About Us",
      },
      {
        section_id: "HOME_01_ES",
        description: "Acerca de nosotros",
      },
      {
        section_id: "HOME_02_EN",
        description:
          "Frontera Copper Corporation is an operating mine located in northwestern Mexico",
      },
      {
        section_id: "HOME_02_ES",
        description:
          "Frontera Copper Corporation es una mina en operación ubicada en el noroeste de México.",
      },
      {
        section_id: "HOME_03_EN",
        description: "ESG",
      },
      {
        section_id: "HOME_03_ES",
        description: "ASG",
      },
      {
        section_id: "HOME_04_EN",
        description: "ESG: Communities",
      },
      {
        section_id: "HOME_04_ES",
        description: "ESG: Comunidades",
      },
      {
        section_id: "HOME_05_EN",
        description:
          "We place great importance on our relationship with our surrounding communities.",
      },
      {
        section_id: "HOME_05_ES",
        description:
          "Damos gran importancia a nuestra relación con las comunidades que nos rodean.",
      },
      {
        section_id: "HOME_06_EN",
        description: "ESG: Health and Safety",
      },
      {
        section_id: "HOME_06_ES",
        description: "ESG: Salud y Seguridad",
      },
      {
        section_id: "HOME_07_EN",
        description:
          "Extensive training programs combined with rigorous analysis of all anormal operations and prompt corrective action.",
      },
      {
        section_id: "HOME_07_ES",
        description:
          "Amplios programas de entrenamiento combinados con un análisis riguroso de todas las operaciones anormales y una pronta acción correctiva.",
      },
      {
        section_id: "HOME_08_EN",
        description: "ESG: Water & Environment",
      },
      {
        section_id: "HOME_08_ES",
        description: "ESG: Agua y Medio Ambiente",
      },
      {
        section_id: "HOME_09_EN",
        description:
          "We comply with official regulations to the highest standards and progressively improving our contribution to the environment.",
      },
      {
        section_id: "HOME_09_ES",
        description:
          "Cumplimos las normativas oficiales con los más altos estándares y mejorando progresivamente nuestra contribución al medio ambiente.",
      },
    ]);

    const fetchData = async () => {
      try {
        const dataForm = {
          page: "HOME",
          language: getLanguage(),
        };
        const response = await getSectionByPageandlanguage(dataForm);
        if (response.status === 200) {
          if (parseInt(response.data.length) !== 0) {
            dataHome.value = response.data;
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const filterData = (found_id) => {
      const filteredData = dataHome.value.filter(
        (item) => item.section_id === found_id
      );
      return filteredData.length > 0 ? filteredData[0].description : null;
    };

    const searchImage = (imageId) => {
      const foundImage = imagesAbout.value.find(
        (image) => image.image_id === imageId
      );
      return foundImage ? BASEURL + foundImage.image_path : null;
    };

    const getImages = async () => {
      try {
        const dataForm = {
          page: "HOME",
        };
        const result = await getImageBySection(dataForm);
        if (result.status === 200) {
          if (result.data.content !== null) {
            imagesAbout.value = result.data.content;
          }
        }
      } catch (error) {
        console.log("Error fetching images:", error);
      }
    };

    onMounted(() => {
      fetchData();
      getImages();
    });

    return {
      BASEURL,
      language: getLanguage(),
      seeMore,
      nextSlide,
      prevSlide,
      seeMoreEsg,
      seeMoreGallery,
      filterData,
      getImages,
      searchImage,
      availableSlides,
    };
  },
};
</script>

<style scoped>
.m-0 {
  margin: 0 !important;
}
.about-container {
  width: 100%;
}

.video-container {
  width: 100%;
  position: relative;
  overflow: hidden;
}

.video-poster {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 5;
  transition: opacity 0.5s erase;
}

.video-poster.hidden {
  opacity: 0;
  pointer-events: none;
}

.video-poster img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.video-wrapper {
  position: relative;
  padding-bottom: 56.25%;
  /* Esto asegura una proporción 16:9 */
  height: 0;
  overflow: hidden;
}

.video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.about-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  padding: 4rem 2rem;
  background: #e4e5e5;
  height: 545px;
}

.image-gallery {
  display: flex;
  align-items: center;
  position: relative;
}

.image-left {
  width: 265px;
  height: 425px;
  overflow: hidden;
}

.image-left img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.image-right {
  width: 255px;
  height: 225px;
  position: absolute;
  bottom: 150px;
  left: 100px;
  z-index: 1;
  will-change: transform;
  overflow: hidden;
}

.image-right img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.about-content {
  max-width: 430px;
  margin-left: 120px;
  margin-right: 96px;
  margin-top: -36px;
}

@media screen and (max-width: 768px) {
  .image-right {
  width: 175px;
  height: 155px;
  position: absolute;
  bottom: 150px;
}
  .about-section {
    flex-direction: column;
    padding: 2rem 1rem;
    height: auto;
  }

  .image-gallery {
    flex-direction: column;
    align-items: center;
  }

  .about-content {
    margin-left: 16px;
    max-width: 90%;
    margin-top: -16px;
    text-align: start;
    margin-bottom: 24px;
    margin-right: 16px;
  }
}

/* Estilos para la sección ESG */
.esg-section {
  padding: 2rem 0.5rem;
  background: #d32a28;
}

.esg-section h2 {
  color: white;
}

.esg-container {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 2rem;
  max-width: 720px;
  margin: 0 auto;
}

.esg-card {
  flex: 1;
  min-width: 200px;
  max-width: 250px;
  background: #d32a28;
  border-radius: 8px;
  overflow: hidden;
  transition: transform 0.3s;
}

.esg-card:hover {
  transform: translateY(-0.1px);
}

.esg-image-placeholder {
  height: 200px;
  background: #e0e0e0;
  overflow: hidden;
}

.esg-image-placeholder img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.esg-content {
  padding: 0.5rem;
}

.esg-content h3 {
  color: #fffbfb;
  margin-bottom: 0.5rem;
}

.esg-content p {
  color: #f9f6f6;
  margin-left: 0;
}

/* Estilos para la sección Galería */
.gallery-section {
  padding: 2rem 2rem;
  background: #130c0e;
  text-align: center;
}

.gallery-section h2 {
  color: white;
}

.carousel-container {
  position: relative;
  max-width: 800px;
  margin: 2rem auto;
  overflow: hidden;
}

.carousel-track {
  display: flex;
  transition: transform 0.5s ease;
}

.carousel-slide {
  min-width: 50%;
}

.gallery-image-placeholder {
  height: 400px;
  background: #e0e0e0;
  margin: 0 10px;
  overflow: hidden;
}

.gallery-image-placeholder img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
  z-index: 10;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-btn:hover {
  background: rgba(0, 0, 0, 0.8);
}

.prev {
  left: 10px;
}

.next {
  right: 10px;
}

.home-01 {
  font-family: "Now", sans-serif;
  font-weight: bold;
  font-size: 2.5rem;
  line-height: 2.8rem;
  color: #130c0e;
}

@media screen and (max-width: 768px) {
  .esg-card {
    max-width: 350px;
  }

  .esg-image-placeholder {
    height: 350px;
  }
}

@media screen and (min-width: 1200px) {
  .esg-container {
    max-width: 1200px;
  }
  .esg-card {
    max-width: 350px;
  }

  .esg-image-placeholder {
    height: 350px;
  }
}
</style>